<template>
  <q-drawer :model-value="drawer" @update:model-value="toggleDrawer" side="left" bordered>
    <q-btn icon="chevron_left" flat round @click="toggleDrawer" class="q-mt-md q-ml-md text-primary" />
    
    <!-- Drawer content -->
    <q-list>
      <q-item-label header>Tickets</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/jobs/list">
        <q-item-section class="text-primary">Crop Ticket Jobs</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/ticket_crop/list">
        <q-item-section class="text-primary">Crop Tickets</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/ticket_haul/list">
        <q-item-section class="text-primary">Haul Tickets</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/ticket_delivery/list">
        <q-item-section class="text-primary">Delivery Tickets</q-item-section>
      </q-item>
      <q-item-label header>Reports</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/report_runner">
        <q-item-section class="text-primary">View Reports</q-item-section>
      </q-item>
      <q-item-label header>Administration</q-item-label>
      <q-item clickable v-ripple tag="router-link" :to="companyInfoLink">
        <q-item-section class="text-primary">Company Information</q-item-section>
      </q-item>
      <q-item-label header>Customers</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/customers/list">
        <q-item-section class="text-primary">Customer List</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/customers/add">
        <q-item-section class="text-primary">Add Customer</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/customer_rates/list">
        <q-item-section class="text-primary">Customer Rates</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/bag_pit_types/list">
        <q-item-section class="text-primary">Bag Pit Types</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/customer_bag_pits/list">
        <q-item-section class="text-primary">Customer Bag Pits</q-item-section>
      </q-item>
      <q-item-label header>Haul</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/haulers/list">
        <q-item-section class="text-primary">Hauler List</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/hauler/add">
        <q-item-section class="text-primary">Add Hauler</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/drivers/list">
        <q-item-section class="text-primary">Driver List</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/driver/add">
        <q-item-section class="text-primary">Add Driver</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/trucks/list">
        <q-item-section class="text-primary">Trucks List</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/truck/add">
        <q-item-section class="text-primary">Add Truck</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/miles/list">
        <q-item-section class="text-primary">Miles</q-item-section>
      </q-item>
      <q-item-label header>Producer</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/producers/list">
        <q-item-section class="text-primary">Producers</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/feedmills/list">
        <q-item-section class="text-primary">Feedmills</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/fields/list">
        <q-item-section class="text-primary">Fields</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/producer/add">
        <q-item-section class="text-primary">Add Producer</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/producer_areas/list">
        <q-item-section class="text-primary">Producer Areas</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/producer_rates/list">
        <q-item-section class="text-primary">Producer Rates</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/producer_area_rates/list">
        <q-item-section class="text-primary">Producer Area Rates</q-item-section>
      </q-item>
      <q-item-label header>Products</q-item-label>
      <q-item clickable v-ripple tag="router-link" to="/crops/list">
        <q-item-section class="text-primary">Crops</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/crops/add">
        <q-item-section class="text-primary">Add Crop</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/feed/list">
        <q-item-section class="text-primary">Feed List</q-item-section>
      </q-item>
      <q-item clickable v-ripple tag="router-link" to="/feed/add">
        <q-item-section class="text-primary">Add Feed</q-item-section>
      </q-item>
    </q-list>
    <br><br>
  </q-drawer>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SideBar',
  props: {
    drawer: Boolean // Drawer state passed from parent
  },
  data() {
    return {
      companyInfoLink: '/company_info/add', // Default link to add company info
    };
  },
  created() {
    this.checkCompanyInfo();
  },
  methods: {
    // Toggle drawer state and emit event to parent
    toggleDrawer() {
      this.$emit('toggleDrawer');
    },
    
    // Check if company info exists and set the link accordingly
    async checkCompanyInfo() {
      try {
        const response = await axios.get('/api/v1/company_info/company_info/');
        if (response.data.length > 0) {
          const firstCompanyId = response.data[0].id; // Assuming the first item is used
          this.companyInfoLink = `/company_info/edit/${firstCompanyId}`;
        }
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    }
  }
}
</script>

<style>
.q-item__label {
  font-size: 1.3rem !important;
  font-weight: bold !important;
}
</style>
